import { foregroundOn, initialOf } from "../../tokens/palette.js";

/**
 * Who the colours mean, in two rows.
 *
 * One row of five names is nearly six hundred pixels of header, and the month
 * view puts a title, a stamp, a month nav and a view toggle on that same line —
 * "September 2026" is enough wider than "August 2026" to push the whole thing
 * off the right edge. Two rows costs a little height and takes that risk away
 * for good, whatever the month is called.
 *
 * Split rather than wrapped: a flex wrap breaks wherever the names happen to
 * land, so the same household would reflow every time somebody's name changed.
 */
export function KitchenLegend({
  people,
  size = 30,
}: {
  people: { id: string; display_name: string; color: string }[];
  size?: number;
}): React.JSX.Element {
  const perRow = Math.ceil(people.length / 2);
  const rows = [people.slice(0, perRow), people.slice(perRow)].filter((row) => row.length > 0);

  return (
    <div className="kd-legend">
      {rows.map((row) => (
        <div key={row[0]?.id ?? "row"} className="kd-legend__row">
          {row.map((person) => (
            <span key={person.id} className="kd-legend__item">
              <span
                className="disc"
                style={{
                  width: size,
                  height: size,
                  background: person.color,
                  color: foregroundOn(person.color),
                  fontSize: size * 0.45,
                }}
              >
                {initialOf(person.display_name)}
              </span>
              {person.display_name}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}
